document.addEventListener('DOMContentLoaded', function () {
  initGaleriaProducto();
  initOpcionesProducto();
  initCarruselHero();
});

function initCarruselHero() {
  // Carrusel del hero (mt-banner-comprar): la foto principal rota sola entre
  // fotos de situación; al hacer clic en cualquier miniatura (de situación o
  // de producto real) se muestra esa foto fija en una capa por encima de los
  // slides y se detiene visualmente la rotación.
  document.querySelectorAll('.mt-bc-galeria').forEach(function (galeria) {
    var manual = galeria.querySelector('.mt-bc-manual');
    var manualImg = manual ? manual.querySelector('img') : null;
    var manualFrase = manual ? manual.querySelector('.mt-bc-manual-frase-texto') : null;
    var minis = galeria.querySelectorAll('.mt-galeria-mini');
    if (!manual || !manualImg || !minis.length) return;
    minis.forEach(function (btn) {
      btn.addEventListener('click', function () {
        manualImg.src = btn.getAttribute('data-full');
        var frase = btn.getAttribute('data-frase');
        if (frase) {
          manualFrase.textContent = frase;
          manual.classList.add('mt-bc-manual-tiene-frase');
        } else {
          manualFrase.textContent = '';
          manual.classList.remove('mt-bc-manual-tiene-frase');
        }
        manual.classList.add('mt-bc-manual-activo');
        minis.forEach(function (b) { b.classList.remove('mt-activa'); });
        btn.classList.add('mt-activa');
      });
    });
  });
}

function initGaleriaProducto() {
  // Puede haber más de una galería en la misma página (ej. el banner de arriba
  // y la ficha completa de producto más abajo), así que cada una se resuelve
  // dentro de su propio contenedor .mt-producto-galeria, no por ID global.
  document.querySelectorAll('.mt-producto-galeria').forEach(function (galeria) {
    var principal = galeria.querySelector('.mt-galeria-principal img');
    var minis = galeria.querySelectorAll('.mt-galeria-mini');
    if (!principal || !minis.length) return;
    minis.forEach(function (btn) {
      btn.addEventListener('click', function () {
        principal.src = btn.getAttribute('data-full');
        minis.forEach(function (b) { b.classList.remove('mt-activa'); });
        btn.classList.add('mt-activa');
      });
    });
  });
}

function initOpcionesProducto() {
  var wrap = document.getElementById('mt-opciones');
  if (!wrap) return;
  var variantes;
  try {
    variantes = JSON.parse(wrap.getAttribute('data-variants'));
  } catch (e) {
    return;
  }
  var grupos = wrap.querySelectorAll('.mt-opcion-valores');
  var seleccion = [];
  grupos.forEach(function (grupo) {
    var activo = grupo.querySelector('.mt-opcion-valor.mt-activa');
    seleccion.push(activo ? activo.getAttribute('data-valor') : null);
  });

  function actualizar() {
    var variante = variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === seleccion[i]; });
    });
    var idInput = document.getElementById('mt-variant-id');
    var boton = document.getElementById('mt-boton-comprar');
    var textoBoton = document.getElementById('mt-boton-texto');
    var precioEl = document.querySelector('.mt-precio-actual');
    var tachadoEl = document.querySelector('.mt-precio-tachado');
    if (!variante) {
      boton.disabled = true;
      return;
    }
    idInput.value = variante.id;
    if (precioEl) precioEl.textContent = formatoMoneda(variante.price);
    if (tachadoEl) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        tachadoEl.textContent = formatoMoneda(variante.compare_at_price);
        tachadoEl.style.display = '';
      } else {
        tachadoEl.style.display = 'none';
      }
    }
    if (variante.available) {
      boton.disabled = false;
      textoBoton.textContent = boton.getAttribute('data-texto-disponible') || textoBoton.textContent;
    } else {
      boton.disabled = true;
      textoBoton.textContent = boton.getAttribute('data-texto-agotado') || textoBoton.textContent;
    }
  }

  function formatoMoneda(centavos) {
    return (centavos / 100).toLocaleString(document.documentElement.lang || 'es', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
  }

  grupos.forEach(function (grupo, indice) {
    grupo.querySelectorAll('.mt-opcion-valor').forEach(function (btn) {
      btn.addEventListener('click', function () {
        grupo.querySelectorAll('.mt-opcion-valor').forEach(function (b) { b.classList.remove('mt-activa'); });
        btn.classList.add('mt-activa');
        seleccion[indice] = btn.getAttribute('data-valor');
        actualizar();
      });
    });
  });
}
